import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettingsModel } from '../Modelo/AppSettings.Model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private _http: HttpClient) { }

  async get(): Promise<AppSettingsModel> {
    try {
      return await this._http.get<AppSettingsModel>('./assets/Settings/appsettings.json').toPromise();
    } catch (error) {
      if (environment.Debug)
        console.error(`An error occurred while trying to dynamically fetch the app settings. Error: ${error}`)

      return null;
    }
  }
}
